import { mapState } from 'vuex'
import { TipoControladorSenha } from '@/utils/controladores'
import { Pesagem } from '@/utils/pesagem'

function dataPesagemPorTipoId(agendamento, tipoPesagemId) {
  if (tipoPesagemId === Pesagem.Tara.id) {
    return agendamento?.pesagem_tara != null
      ? agendamento.pesagem_tara.data
      : '-'
  }
  if (tipoPesagemId === Pesagem.Bruto.id) {
    return agendamento?.pesagem_bruto != null
      ? agendamento.pesagem_bruto.data
      : '-'
  }
  return '-'
}

export const computed = {
  ...mapState('auth', ['empresaAtual']),
  ...mapState('agendamentos', ['agendamento']),
  getSenha() {
    let senha = this.agendamento.senhas.filter(
      item =>
        item.tipo == TipoControladorSenha.Produto.id ||
        item.tipo == TipoControladorSenha.SubProduto.id
    )[0]
    return senha
  },

  mostraItem() {
    if(this.agendamento.gate.public_id == '4856f9c1-94d6-4daa-90b6-5b9d4e5c44c8'){
      return false
    }

    if(this.agendamento.gate.public_id == '9c027477-7337-4b6f-b686-9079a35dd1c0'){
      return false
    }
    return true
  },

  comprovanteDataEntrada() {
    return dataPesagemPorTipoId(
      this.agendamento,
      this.tipos.ENTRADA[
        this.agendamento?.tipo_operacao?.descricao?.toLowerCase()
      ] ?? this.tipos.ENTRADA.default
    )
  },

  comprovanteDataSaida() {
    const tipoEntradaId =
      this.tipos.ENTRADA[
        this.agendamento?.tipo_operacao?.descricao?.toLowerCase()
      ] ?? this.tipos.ENTRADA.default
    const tipoSaidaId =
      tipoEntradaId === Pesagem.Tara.id ? Pesagem.Bruto.id : Pesagem.Tara.id
    return dataPesagemPorTipoId(this.agendamento, tipoSaidaId)
  },
}
